// extracted by mini-css-extract-plugin
module.exports = {"HomeSection":"HomeSection_HomeSection__BVBaF","container":"HomeSection_container__2OGFs","backvid":"HomeSection_backvid__DWVcl"};